export function getUsernameFromLinkedinUrl(linkedinURL: string | URL): string {
	const url = new URL(linkedinURL);
	const hostname = url.hostname.replace(/^www\./u, "");

	if (hostname !== "linkedin.com") {
		throw new Error("Invalid LinkedIn URL: Unsupported hostname. Expected 'linkedin.com'.");
	}

	const [firstSegment, username] = url.pathname.split("/").filter(Boolean);

	if (firstSegment !== "in") {
		throw new Error("Invalid LinkedIn URL: Expected profile URL starting with '/in/'.");
	}

	if (!username) {
		throw new Error("Invalid LinkedIn URL: No username found.");
	}

	return decodeURIComponent(username.replace(/(?:[-]\w*\d+\w*)+$/gu, ""));
}
